import Tooltip from "app/component/tooltip/Tooltip";
import React, { FC } from "react";
import { Form } from "react-bootstrap";

interface Props {
  isWidget: boolean;
  value: string;
  onChange: (event: any) => void;
  disabled?: boolean;
  valid: boolean;
  regexpText?: string | undefined;
  tabIndex?: 0 | -1 | undefined;
}

const CustomPropertyInput: FC<Props> = ({
  isWidget,
  value,
  onChange,
  disabled,
  valid,
  regexpText,
  tabIndex,
}) => {
  return (
    <Tooltip
      fontSize={14}
      width={350}
      textArray={[regexpText]}
      active={!valid}
      notHovered={true}
      block={true}
    >
      {isWidget ? (
        <Form.Control
          type="text"
          value={value}
          onChange={onChange}
          placeholder={"Введите значение "}
          disabled={disabled}
          style={{ fontSize: "16px" }}
          tabIndex={tabIndex}
        />
      ) : (
        <input
          className="input"
          type="text"
          value={value}
          onChange={onChange}
          placeholder={"Введите значение "}
          disabled={disabled}
          style={{ fontSize: "16px" }}
          tabIndex={tabIndex}
        />
      )}
    </Tooltip>
  );
};

export default CustomPropertyInput;
